import React from "react";
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom'
import hero7 from '../../images/slider/kihi-banner.webp'
import hero8 from '../../images/slider/banner1.webp'
import hero9 from '../../images/slider/banner2.webp'


const HeroSlider = (props) => {
    return (

        <section className={"" + props.hclass} >
            <Swiper
                // install Swiper modules
                modules={[Navigation, A11y]}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                speed={1800}
                parallax={true}
                navigation
            >
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero8})` }}>
                        <div className="container-fluid">
                            <div className="slide-content">
                                <div className="slide-title">
                                    <h2>Trusted Name in Earthing, lightning protection & Cable trays </h2>
                                </div>
                                <div className="slide-text">
                                    <p>Wholesaler & Retailers in Earthing Solution <br /> & Accessories, Lighting Arrestors & Manufacturing of Cable Trays </p>
                                </div>
                                {/* <div className="slide-btns">
                                    <Link to="/about" className="theme-btn">About Us</Link>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero7})` }}>
                        <div className="container-fluid">
                            <div className="slide-content">
                                <div className="slide-title">
                                    <h2>we are industry factory solution</h2>
                                </div>
                                <div className="slide-text">
                                    <p>Reliable solutions for your industrial <br /> infrastructure needs with guaranteed quality.</p>

                                </div>
                                {/* <div className="slide-btns">
                                    <Link to="/about" className="theme-btn">About Us</Link>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero9})` }}>
                        <div className="container-fluid">
                            <div className="slide-content">
                                <div className="slide-title">
                                    <h2>We Are The Best In The Industry</h2>
                                </div>
                                <div className="slide-text">
                                    <p>Delivering trusted products and services that <br /> power industries worldwide.</p>
                                </div>
                                {/* <div className="slide-btns">
                                    <Link to="/about" className="theme-btn">About Us</Link>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

                ...
            </Swiper>
        </section>
    )
}

export default HeroSlider;